import { render, staticRenderFns } from "./CheckFunction.vue?vue&type=template&id=873166a6&scoped=true&"
import script from "./CheckFunction.vue?vue&type=script&lang=js&"
export * from "./CheckFunction.vue?vue&type=script&lang=js&"
import style0 from "./CheckFunction.vue?vue&type=style&index=0&id=873166a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873166a6",
  null
  
)

export default component.exports